const APPOINTMENT_DEFAULT_COLOR = '#17294c';
export { APPOINTMENT_DEFAULT_COLOR };
